/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Handlebars from 'handlebars';
import { View } from 'backbone.marionette';
import NavUtils from 'psa-core/util/nav';

// This view is esentially an abstract view, in which other views will always
// extend, and provide their own custom templates. This view simply provides the
// functionality for highlighting the correct link based on the currently active
// page.
const SidebarNavView = View.extend({
  //
  template: Handlebars.compile(''),

  className: 'side-bar-nav-view',

  ui: {
    menuItem: '.menu-item'
  },

  onRender() {
    const currentRoute = NavUtils.getCurrentRoute();
    this.$el.find(`.menu-item[href="#${currentRoute}"]`).closest('li').addClass('active');
  }
});

export default SidebarNavView;
